import {create} from 'zustand';
import type {IUser} from '../schema/user';
import {userDefaults} from '../defaults';

// TODO: get this data from the server via react-query?
// probably can't until we have the user editor switched over and whatnot
// Then we perhaps just lift this up to a context tree as very little about the user ever changes
// not entirely sure the best route yet

interface CurrentUserState {
	user: IUser;
}

export const useCurrentUser = create<CurrentUserState>()((set) => ({
	user: {
		...userDefaults,
		// We have so many checks that epxect this to be less than 0 if the user is not logged in
		// @ts-ignore
		type: -1,
	},
}));
